import { Link, LinkProps } from '../atoms/Link';
import { mapToLinkButtonClasses } from '../../../lib/mapLinkButtonClasses';
import { ColorOptions } from '../../../types/colorOptions';

const defaultQuickLinksClass =
	'flex flex-wrap justify-center gap-4 sm:px-8';
const defaultLinkItemClass =
	'flex flex-row items-center gap-2 px-4 py-2 rounded-2xs cursor-pointer';

const getItemClass = (
	colorOptions?: ColorOptions,
	itemOverrideClass?: string,
) => {
	if (itemOverrideClass) {
		return itemOverrideClass;
	}

	return `${defaultLinkItemClass} ${mapToLinkButtonClasses(colorOptions)}`;
};

export interface QuickLinksProps {
	items: LinkProps[];
	linkColorOptions: ColorOptions;
	overrideItemClass?: string;
}

export const QuickLinks = ({
	items,
	linkColorOptions,
	overrideItemClass,
}: QuickLinksProps) => {
	return (
		<div className={defaultQuickLinksClass}>
			{items.map((item, id) => (
				<Link
					key={`${item.label}-${id}`}
					label={item.label}
					className={getItemClass(linkColorOptions, overrideItemClass)}
					icon={item.icon}
					url={item.url}
				/>
			))}
		</div>
	);
};
